import React from 'react';
import Material from './Material';

/**
 * 自定义图片组件
 * 
 * 加载本地文件路径  let src = 'assets/images/xxx/xxx.png';  以'assets/'开始
 * 加载服务器文件路径  let src = `${ele.preview}`; 不以'assets/'开始
 *
 */
export default class Music extends Material {
  
  render() {
    return (
      <audio style={{ clear:'both', display:'block', margin:'auto' }} {...this.props} src={this.state.src} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Material/Music.js